export const decodeJwtExp = (token: string | null): number | null => {
	if (!token) return null;
	try {
			const parts = token.split('.');
			if (parts.length < 2) return null;
			const base = parts[1].replace(/-/g, '+').replace(/_/g, '/');
			const padded = base.padEnd(base.length + (4 - (base.length % 4)) % 4, '=');
			const json = atob(padded);
			const data = JSON.parse(json);
			return typeof data.exp === 'number' ? data.exp : null;
	} catch {
			return null;
	}
};